import { ProductGroup } from 'rangeConfig/@types';
import { FramesIcon } from 'components/ProductSidebar/ProductGroupNav/ProductGroupNavSVGs';
import selectedMenu from './selectedMenu';
import { ProductType } from '@inter-ikea-storageone/range';
import mainMenu from './mainMenu';

const fronts = (): ProductGroup => {
  return {
    id: 'cabinets',
    productTypes: [ProductType.IVAR_CABINET, ProductType.IVAR_CABINET_WITH_UNDERFRAME],
    icon: FramesIcon,
    mainMenu,
    selectedMenu: selectedMenu()
  };
};

export default fronts;
